module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-carousel"
  }, [_c('div', [_c('ul', {
    staticClass: "task-carousel-pager pager"
  }, [_c('li', {
    staticClass: "previous",
    class: _vm.isFirstPage ? 'disabled' : ''
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.gotoStartPage
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "previous",
    class: _vm.isFirstPage ? 'disabled' : ''
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "next"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.daysVisible), function(d) {
    return _c('div', {
      staticClass: "task-carousel-column",
      class: _vm.isZoomedDay(_vm.getDateFromOffset(d - 1)) ? 'col-lg-6' : 'col-lg-1'
    }, [_c('h4', {
      staticClass: "text-center user-action",
      on: {
        "click": function($event) {
          _vm.updateZoomedDay(_vm.getDateFromOffset(d - 1))
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(_vm.getDateFromOffset(d - 1), 'dddd')) + "\n                "), _c('br'), _vm._v(" "), _c('small', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.getDateFromOffset(d - 1), 'MMM Do \'YY')))])]), _vm._v(" "), (_vm.isDataLoaded) ? _c('ul', {
      staticClass: "list-group"
    }, [_vm._l((_vm.tasks[_vm.getDateFromOffset(d - 1, 'YYYY-MM-DD')]), function(t) {
      return _c('li', {
        staticClass: "list-group-item",
        class: t.length ? 'grouped-items' : ''
      }, [(!t.length) ? _c('carousel-item', {
        attrs: {
          "item": t,
          "collapsed": !_vm.isZoomedDay(_vm.getDateFromOffset(d - 1))
        }
      }) : _c('div', [_c('div', {
        staticClass: "user-action",
        on: {
          "click": function($event) {
            _vm.toggleGroup(t)
          }
        }
      }, [_c('span', {
        staticClass: "glyphicon",
        class: {
          'glyphicon-expand': !t[2], 'glyphicon-collapse-down': t[2]
        }
      }), _vm._v("\n                            " + _vm._s(t[1].length) + " tasks from " + _vm._s(t[0]) + "\n                        ")]), _vm._v(" "), (t[2]) ? _c('ul', {
        staticClass: "list-group"
      }, _vm._l((t[1]), function(ts) {
        return _c('li', {
          staticClass: "list-group-item"
        }, [_c('carousel-item', {
          attrs: {
            "item": ts,
            "collapsed": !_vm.isZoomedDay(_vm.getDateFromOffset(d - 1))
          }
        })], 1)
      })) : _vm._e()]), _vm._v(" "), _c('span', {
        staticClass: "clearfix"
      })], 1)
    }), _vm._v(" "), (!_vm.tasks[_vm.getDateFromOffset(d - 1, 'YYYY-MM-DD')] || !_vm.tasks[_vm.getDateFromOffset(d - 1, 'YYYY-MM-DD')].length) ? _c('li', {
      staticClass: "list-group-item text-center"
    }, [_vm._v("\n                    0 items\n                ")]) : _vm._e()], 2) : _vm._e()])
  })), _vm._v(" "), (!_vm.isDataLoaded) ? _c('div', {
    staticClass: "loader text-center"
  }, [_c('div', {
    staticClass: "well well-sm"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (_vm.errorMsg.length) ? _c('div', {
    staticClass: "error-message text-center"
  }, [_c('div', {
    staticClass: "well well-sm bg-danger"
  }, [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c902f72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/TaskCarousel.vue
// module id = 1096
// module chunks = 0